const blockChatConst =
  '+NjSRRW1lPggeqleTXDt/HtjO4MqkwL3pNcPzkPcL7No1ih5Jm6G6dp1uzZd233JZRnjpUt4fgBwH'
const unblockChatConst =
  'pgciFniskM6vHj7TPg5eMoDe2MRe58jBBkMHKlLou9qMPZxENADgegHNpHBKAPMZbaFKL0Wbp6'

export { blockChatConst, unblockChatConst }
